// CYRIL product rows ("You might also like" on product pages, "The full lineup." on the home page): every
// product card in a row steps to its next colour in the same frame. The next
// photos are downloaded and decoded first, so no card changes before the others. A card stops cycling only
// once the shopper picks a colour on it (click or swipe); hovering never pauses the row. The timer runs only
// while the row is on screen and the tab is visible; reduced motion turns it off.
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const INTERVAL = 2500;
  const LOAD_LIMIT = 2000;
  const rows = document.querySelectorAll('.shopify-section[id$="__cyril_you_might_also_like"], .shopify-section[id$="__cyril_home_all"]');
  rows.forEach((section) => cycle(section));

  function cycle(section) {
    let step = 0;
    let timer = 0;
    let visible = false;
    let busy = false;
    // Swatch button this script last pressed on each card; anything else pressed means the shopper chose.
    const expected = new WeakMap();
    const pinned = new WeakSet();

    const cards = () => [...section.querySelectorAll('color-swatch')].filter((swatch) => {
      const buttons = swatch.querySelectorAll('.cyril-card-swatch-button');
      if (buttons.length < 2 || pinned.has(swatch)) return false;
      const pressed = swatch.querySelector('.cyril-card-swatch-button[aria-pressed="true"]');
      const mine = expected.get(swatch);
      if (mine ? pressed !== mine : pressed !== buttons[0]) {
        pinned.add(swatch);
        return false;
      }
      return true;
    });

    const nextButton = (swatch, at) => {
      const buttons = swatch.querySelectorAll('.cyril-card-swatch-button');
      return buttons[at % buttons.length];
    };

    const preload = (src) => new Promise((resolve) => {
      if (!src) return resolve();
      const image = new Image();
      image.src = src;
      (image.decode ? image.decode() : Promise.reject()).then(resolve, () => {
        if (image.complete) return resolve();
        image.onload = image.onerror = () => resolve();
      });
    });

    const keepInView = (swatch, button) => {
      const list = swatch.querySelector('.swatch-list');
      const item = button.closest('.swatch-item');
      if (!list || !item || list.scrollWidth <= list.clientWidth) return;
      const left = item.offsetLeft - list.offsetLeft;
      const right = left + item.offsetWidth;
      if (left < list.scrollLeft || right > list.scrollLeft + list.clientWidth) {
        list.scrollTo({ left: Math.max(0, right - list.clientWidth), behavior: 'smooth' });
      }
    };

    const advance = async () => {
      const targets = cards().map((swatch) => ({ swatch, button: nextButton(swatch, step + 1) }));
      if (!targets.length) return;
      busy = true;
      // Wait for every next photo (or give up after LOAD_LIMIT), then switch them all together.
      await Promise.race([
        Promise.all(targets.map(({ button }) => preload(button.dataset.variantImg))),
        new Promise((resolve) => setTimeout(resolve, LOAD_LIMIT)),
      ]);
      busy = false;
      if (!visible || document.hidden) return;
      step += 1;
      requestAnimationFrame(() => {
        const fresh = new Set(cards());
        targets.forEach(({ swatch, button }) => {
          if (!fresh.has(swatch)) return;
          if (button.getAttribute('aria-pressed') !== 'true') button.click();
          expected.set(swatch, button);
          keepInView(swatch, button);
        });
      });
    };

    const stop = () => {
      clearTimeout(timer);
      timer = 0;
    };

    const schedule = () => {
      stop();
      if (!visible || document.hidden) return;
      timer = setTimeout(async () => {
        if (!busy) await advance();
        schedule();
      }, INTERVAL);
    };

    new IntersectionObserver((entries) => {
      visible = entries.some((entry) => entry.isIntersecting);
      if (visible) schedule();
      else stop();
    }, { threshold: 0.2 }).observe(section);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else schedule();
    });
  }
})();
